module.exports = __webpack_public_path__ + "static/media/placeholder.7bc371c3.jpeg";